export default __webpack_public_path__ + "static/media/Monger-HUD-Pop-Up (Info, Large).16a47ca3.jpg";